<div class="front-wrap">
  <div class="front-store-content">
    <div class="container">
     

      <i *ngIf="mobileScreen" class="fa fa-filter mobile-filter-icon d-md-none" aria-hidden="true"
         data-toggle="modal" data-target="#open-mobile-filter"></i>

      <div class="row">
        <div class="col-md-3 d-none d-md-block" *ngIf="!mobileScreen">
          <h5 class="page-title">
          &nbsp;
          </h5>

          <app-filter (getProducts)="updateProductList($event)"
                      [filterModel]="filterModel"
                      [filterList]="filterList"
                      [pageSize]="pageSize"
                       [searchCustomizedForm]="searchCustomizedForm"></app-filter>
        </div>

        <div class="col-md-9">
          <div class="row">
            <div class="col-sm-12">
              <form class="searcProductsCustomized" [formGroup]="searchCustomizedForm">
                <i class="fa fa-search" aria-hidden="true"></i>
                <input matInput placeholder="Search Products..." class="w-100" formControlName="searchProduct"
                       ng-model-options="{debounce: 10000}" (change)="fn_searchCustomizeProduct(searchCustomizedForm)">
              </form>
            </div>
          </div>

          <div class="search-results" style="min-height:80vh">
            <div class="row">
              <div class="col-sm-6 col-lg-3" *ngFor="let product of customizedProducts; index as i">
                <div class="store-item">
                  <div class="store-item-thumb">
                    <span class="dec-type">{{product.CustomizationType}}</span>
                    <div class="cstm-prdct display-table">
                      <div class="display-cell">
                        <div (click)="fn_ViewProduct(product.ProductId, product.DesignId, 1, i, false)">
                          <!-- <img *ngIf="product.IsDefaultImageCustom === true"
       src="{{imgCustomBaseURL + product.DefaultImage}}">
  <img *ngIf="product.IsDefaultImageCustom === false && (product.DefaultImage == '' || product.DefaultImage == null)"
       src="{{product.IsWarehouseProduct == false  ? imgBaseURL + product.PngRelativeUrlWithProduct : product.PngRelativeUrlWithProduct}}">
  <img *ngIf="product.IsDefaultImageCustom === false && (product.DefaultImage != '' && product.DefaultImage != null)"
       src="{{product.IsWarehouseProduct == false ? imgBaseURL + product.DefaultImage : product.DefaultImage}}"> -->
                          <img *ngIf="!product.ImgLoaded" src="/assets/img/load-spinner.gif" alt="loading" />
                          <img *ngIf="!product.IsWarehouseProduct"[src]="product.Img || 'assets/img/no-image-available.jpg'" [hidden]="!product.ImgLoaded" (load)="product.ImgLoaded=true">
                          <img *ngIf="product.IsWarehouseProduct" [src]="product.PngRelativeUrlWithProduct || 'assets/img/no-image-available.jpg'" [hidden]="!product.ImgLoaded" (load)="product.ImgLoaded=true">
                        </div>
                        <div class="store-item-cntnt">
                          <h4>{{product.Name}}</h4>                          
                        </div>

                        <!-- Farbe und GroBe  -->
                        <div class="available-sizes store-item-cntnt">
                          <span *ngFor="let sz of product.Sizes">
                            <span> {{sz.Name}}</span>
                          </span>
                        </div>
                        <div class="color-list store-item-cntnt tick">
                          <!--Conditional based isActive display-->
                          <ng-container *ngFor="let s of product.ColorList">
                            <!--[ngClass]="{'selected-style':s.ID == s.StyleId}"-->
                            <div title="{{s.ColorName}}" class="available-colors"
                                 *ngIf="s.IsActive"
                                 [ngStyle]="displayColor( s.ColorHexCode)"
                                 [ngClass]="{'selected-style':s.StyleId == product.StyleId}"
                                 data-tooltip="s.ColorName"
                                 (click)="selectStyleToCustomize(s, i)">
                            </div>
                            <div title="{{s.ColorName}} ***Discontinued" class="available-colors discontinuedColor"
                                 *ngIf="!s.IsActive"
                                 [ngStyle]="displayColor(s.ColorHexCode)"
                                 [ngClass]="{'selected-style':s.StyleId == product.StyleId}"
                                 data-tooltip="s.ColorName"
                                 (click)="selectStyleToCustomize(s, i)">
                            </div>
                          </ng-container>
                        </div>


                        <!--Conditional based isActive display-->
                        <!--  -->
                        <div class="list-lnk">
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <h6 *ngIf="customizedProducts.length == 0" class="text-center no-rcrd"> No result found</h6>
          </div>
          <app-lazy-loader></app-lazy-loader>
          <div *ngIf="customizedProducts.length > 0">
            <mat-paginator class="pg-nt-blk" [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10,20,50,100]" (page)="fn_GetPaginatedSavedDesignListing($event)">
            </mat-paginator>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="open-mobile-filter" *ngIf="mobileScreen" tabindex="-1" aria-labelledby="open-mobile-filter-enduserLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <app-filter (getProducts)="updateProductList($event)"
                          [filterModel]="filterModel"
                          [filterList]="filterList"
                          [pageSize]="pageSize"
                          [searchCustomizedForm]="searchCustomizedForm"></app-filter>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
